
export default function CTASection() {
  const handleRegister = () => {
    window.open('https://buy.stripe.com/00w7sEaoVdgx2UlapSgIo01', '_blank');
  };

  return (
    <section className="py-16 px-4 bg-teal-600 text-white text-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-0 right-0 w-full h-full"></div>
      </div>
      
      <div className="max-w-2xl mx-auto relative z-10">
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 whitespace-nowrap">
          今すぐBIZCHAIN800に参加しよう
        </h3>
        <p className="text-teal-100 mb-8 text-lg">
          経営者同士のつながりで、あなたのビジネスを次のレベルへ
        </p>
        <div className="flex justify-center">
          <button 
            onClick={handleRegister}
            className="bg-white text-teal-600 hover:bg-teal-50 font-semibold px-8 py-4 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            クレジットカードで登録する
          </button>
        </div>
      </div>
    </section>
  );
}